import useCrossProductUrlWrapper from '@atlassiansox/analytics-cross-product-interaction-client/use-cross-product-url-wrapper';
import { di } from 'react-magnetic-di';

import { fg } from '@atlaskit/platform-feature-flags';

const STUDIO_XPC_PRODUCT = 'atlassianStudio';

const identity = (url: string): string => url;

export type StudioCrossProductBridge = string;

export type StudioCrossProductUrlOptions = {
	bridge: StudioCrossProductBridge;
	/**
	 * Host product the surface is rendered in (XPC `source`). Defaults to
	 * `atlassianStudio`. Pass a falsy value to disable XPC reporting entirely —
	 * used by shared components that render across multiple host products and
	 * must not report when the host product is unknown.
	 */
	product?: string;
};

/** Wraps a URL with XPC tracking; identity no-op when gated off. */
export const useStudioCrossProductUrlWrapper = ({
	bridge,
	product = STUDIO_XPC_PRODUCT,
}: StudioCrossProductUrlOptions): ((url: string) => string) => {
	di(useCrossProductUrlWrapper);
	// Always call the hook (Rules of Hooks); fall back to a stable product so
	// the call is valid even when reporting is disabled below.
	const wrapUrl = useCrossProductUrlWrapper({
		bridge,
		product: product || STUDIO_XPC_PRODUCT,
	});

	// No host product (shared multi-product component with unknown host) or gate
	// off -> do not report XPC.
	if (!product || !fg('asf-1741-studio-xpc')) {
		return identity;
	}

	return wrapUrl;
};
